/**
 * Visual thresholds for UI color coding and badge display.
 * These are purely presentational — game logic thresholds live on the server.
 */

/** Audit risk: green below this, amber above */
export const AUDIT_THRESH_WARN = 0.3;
/** Audit risk: red above this */
export const AUDIT_THRESH_CRIT = 0.6;

/** Expense warn badge (yellow): expense > this fraction of total income */
export const EXPENSE_WARN_PCT = 0.25;
/** Expense crit badge (red): expense > this fraction of total income */
export const EXPENSE_CRIT_PCT = 0.5;

/** Max subsidiary chips shown in the pipeline node */
export const PIPELINE_MAX_CHIPS = 4;
